<template>
    <div class="form_group form_group_contact">
        <display-message :option="message_option"></display-message>

        <div class="form_row" v-show="available_contact_types.length > 1">
            <label :for="'contact_'+contact_id+'_contact_type'" v-html="cache_data_label.contact_type" v-show="cache_data.contact_type"></label>
            <div class="form_static_value" v-show="current_contact.id" v-html="contact_type_display_name(cache_data.contact_type)"></div>
            <div class="select_container" v-show="!current_contact.id">
                <select :id="'contact_'+contact_id+'_contact_type'" :placeholder="cache_data_label.contact_type" v-model="cache_data.contact_type">
                    <option value="" disabled>-- {{ cache_data_label.contact_type }} --</option>
                    <option :value="available_contact_type" v-for="available_contact_type in available_contact_types">{{ contact_type_display_name(available_contact_type) }}</option>
                </select>
            </div>
        </div>

        <div v-if="cache_data.contact_type == 'People'">
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_title'" v-html="cache_data_label.title" v-show="cache_data.title"></label>
                <div class="select_container">
                    <select :id="'contact_'+contact_id+'_title'" :placeholder="cache_data_label.title" v-model="cache_data.title">
                        <option value="" disabled>-- {{ cache_data_label.title }} --</option>
                        <option :value="available_title" v-for="available_title in available_titles">{{ available_title }}</option>
                    </select>
                </div>
            </div>
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_first_name'" v-html="cache_data_label.first_name" v-show="cache_data.first_name"></label>
                <input type="text" :id="'contact_'+contact_id+'_first_name'" :placeholder="cache_data_label.first_name" v-model="cache_data.first_name">
            </div>
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_middle_name'" v-html="cache_data_label.middle_name" v-show="cache_data.middle_name"></label>
                <input type="text" :id="'contact_'+contact_id+'_middle_name'" :placeholder="cache_data_label.middle_name" v-model="cache_data.middle_name">
            </div>
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_last_name'" v-html="cache_data_label.last_name" v-show="cache_data.last_name"></label>
                <input type="text" :id="'contact_'+contact_id+'_last_name'" :placeholder="cache_data_label.last_name" v-model="cache_data.last_name">
            </div>
            <div class="form_row" v-show="contact_for == 'officer'">
                <label :for="'contact_'+contact_id+'_director_id'" v-html="cache_data_label.director_id" v-show="cache_data.director_id"></label>
                <input type="text" :id="'contact_'+contact_id+'_director_id'" :placeholder="cache_data_label.director_id" v-model="cache_data.director_id">
            </div>
            <p v-show="contact_for == 'officer'">* A valid Director ID is required for directors to register new businesses. <a href="https://www.abrs.gov.au/director-identification-number" target="_blank" class="highlight_link">Apply here</a> if do not have one already.</p>
            <div class="form_row" v-show="contact_for == 'officer'">
                <label :for="'contact_'+contact_id+'_birthday'" v-html="cache_data_label.birthday"></label>
                <input type="date" :id="'contact_'+contact_id+'_birthday'" :placeholder="cache_data_label.birthday" v-model="cache_data.birthday">
            </div>
<!--            <div class="form_row">-->
<!--                <label :for="'contact_'+contact_id+'_birth_country'" v-html="cache_data_label.birth_country" v-show="cache_data.birth_country"></label>-->
<!--                <input type="text" :id="'contact_'+contact_id+'_birth_country'" :placeholder="cache_data_label.birth_country" v-model="cache_data.birth_country" maxlength="2">-->
<!--            </div>-->
<!--            <p>* Country in Alpha-2 code, e.g. AU for Australia, US for America, CN for China...</p>-->
            <div class="form_row" v-show="contact_for == 'officer'">
                <label :for="'contact_'+contact_id+'_birth_country'" v-html="cache_data_label.birth_country" v-show="cache_data.birth_country"></label>
                <div class="select_container">
                    <select :id="'contact_'+contact_id+'_birth_country'" :placeholder="cache_data_label.birth_country" v-model="cache_data.birth_country">
                        <option value="" disabled>-- {{ cache_data_label.birth_country }} --</option>
                        <option :value="available_country.alpha2_code" v-for="available_country in available_countries">{{ available_country.full_name }}</option>
                    </select>
                </div>
            </div>
            <div class="form_row" v-show="contact_for == 'officer' && cache_data.birth_country == 'AU'">
                <label :for="'contact_'+contact_id+'_birth_state'" v-html="cache_data_label.birth_state" v-show="cache_data.birth_state"></label>
                <div class="select_container">
                    <select :id="'contact_'+contact_id+'_birth_state'" :placeholder="cache_data_label.birth_state" v-model="cache_data.birth_state">
                        <option value="" disabled>-- {{ cache_data_label.birth_state }} --</option>
                        <option value="NSW">NSW</option>
                        <option value="VIC">VIC</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="WA">WA</option>
                        <option value="TAS">TAS</option>
                        <option value="NT">NT</option>
                        <option value="ACT">ACT</option>
                    </select>
                </div>
<!--                <input v-else type="text" :id="'contact_'+contact_id+'_birth_state'" :placeholder="cache_data_label.birth_state" v-model="cache_data.birth_state">-->
            </div>
            <div class="form_row" v-show="contact_for == 'officer'">
                <label :for="'contact_'+contact_id+'_birth_place'" v-html="cache_data_label.birth_place" v-show="cache_data.birth_place"></label>
                <input type="text" :id="'contact_'+contact_id+'_birth_place'" :placeholder="cache_data_label.birth_place" v-model="cache_data.birth_place">
            </div>
        </div>
        <div v-else-if="cache_data.contact_type == 'Joint Member'">
<!--            <div class="form_row">-->
<!--                <input type="text" v-model="cache_data.representative_ids" maxlength="2">-->
<!--            </div>-->
            <div class="form_row form_row_controller_container">
                <label v-html="cache_data_label.representative_ids"></label>
                <input type="button" class="btn btn-primary" value="Add Representative" @click="current_representative_id = 'new'" style="font-size: 0.6em;" v-show="!current_representative_id">
            </div>
            <div class="form_row_joint_member_candidate_wrapper" v-show="!current_representative_id">
                <div class="form_row_joint_member_candidate_container" v-for="contact in item_list.contacts" v-if="contact.contact_type != 'Joint Member'">
                    <input class="form_row_joint_member_candidate_chosen" type="checkbox" v-model="cache_data.representative_ids" :value="contact.id" >
                    <span class="form_row_joint_member_candidate_name">{{ contact.formatted_name }}</span>
                    <a class="form_row_joint_member_candidate_edit" href="javascript:void(0);" @click="current_representative_id = contact.id"><span class="glyphicon glyphicon-pencil"></span></a>
                </div>
            </div>
            <update-contact v-show="current_representative_id" :current_contact_id="current_representative_id" @submit="update_representative" :option="{item_list:item_list,item_map:item_map,contact_id:'officer_'+current_representative_id,contact_for:'joint_member'}"></update-contact>
        </div>
        <div v-else-if="cache_data.contact_type == 'Trust'">
            <!-- contactType is 'Other Entity'-->
            <p style="font-size: 0.8em;padding: 0 1.5em 1em;margin: 0;">Please ensure you enter the full name of the trust. E.g. "The XYZ Trust"</p>
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_name'" v-show="cache_data.name">Trust Name</label>
                <input type="text" :id="'contact_'+contact_id+'_name'" :placeholder="cache_data_label.name" v-model="cache_data.name">
            </div>
        </div>
        <div v-else>
            <!-- contactType is 'Company'/'Other Entity'-->
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_name'" v-html="cache_data_label.name" v-show="cache_data.name"></label>
                <input type="text" :id="'contact_'+contact_id+'_name'" :placeholder="cache_data_label.name" v-model="cache_data.name">
            </div>
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_company_number'" v-html="cache_data_label.company_number" v-show="cache_data.company_number"></label>
                <input type="text" :id="'contact_'+contact_id+'_company_number'" :placeholder="cache_data_label.company_number" v-model="cache_data.company_number">
            </div>
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_business_number'" v-html="cache_data_label.business_number" v-show="cache_data.business_number"></label>
                <input type="text" :id="'contact_'+contact_id+'_business_number'" :placeholder="cache_data_label.business_number" v-model="cache_data.business_number">
            </div>
        </div>
        <div v-if="cache_data.contact_type != 'Joint Member'">
            <div class="form_row">
                <label :for="'contact_'+contact_id+'_address'" v-html="cache_data_label.address_id" v-show="cache_data.address_id"></label>
                <div class="select_container" v-show="cache_data.address_id !== 'Add New'">
                    <select :id="'contact_'+contact_id+'_address'" v-model="cache_data.address_id" :placeholder="cache_data_label.address_id">
                        <option value="" disabled>-- {{ cache_data_label.address_id }} --</option>
                        <option :value="cached_address.id" v-for="cached_address in item_list.addresses">{{ cached_address.formatted_address }}</option>
                        <option value="Add New">Add New</option>
                    </select>
                </div>
            </div>
            <add-new-address :option="{item_list:item_list,item_map:item_map,address_name:'contact_'+contact_id+'_address'}" v-model:new_address="cache_data.address_id" v-show="cache_data.address_id == 'Add New'"></add-new-address>
            <div class="form_row" v-show="$root.panel === 'admin'">
                <label :for="'contact_'+contact_id+'_email'" v-html="cache_data_label.email" v-show="cache_data.email"></label>
                <input type="text" :id="'contact_'+contact_id+'_email'" :placeholder="cache_data_label.email" v-model="cache_data.email">
            </div>
            <div class="form_row" v-show="$root.panel === 'admin'">
                <label :for="'contact_'+contact_id+'_mobile'" v-html="cache_data_label.mobile" v-show="cache_data.mobile"></label>
                <input type="text" :id="'contact_'+contact_id+'_mobile'" :placeholder="cache_data_label.mobile" v-model="cache_data.mobile">
            </div>
            <div class="form_row" v-show="$root.panel === 'admin'">
                <label :for="'contact_'+contact_id+'_tax_number'" v-html="cache_data_label.tax_number" v-show="cache_data.tax_number"></label>
                <input type="text" :id="'contact_'+contact_id+'_tax_number'" :placeholder="cache_data_label.tax_number" v-model="cache_data.tax_number">
            </div>
        </div>

        <div class="form_row form_row_controller_container" v-show="cache_data.address_id !== 'Add New' && !current_representative_id">
            <input type="button" class="btn btn-primary" value="Save" @click="save()">
            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">
        </div>
    </div>    
</template>

<script>
    export default {
        name: "UpdateContact",
        props: ['current_contact_id','option'],
        data() {
            let data_set = {
                autocomplete: null,
                current_representative_id: '',
                available_titles: ['Mr','Miss','Mrs','Ms','Mstr','Dr'],
                available_countries: [
                    {'full_name':'Afghanistan','alpha2_code':'AF'},
                    {'full_name':'Albania','alpha2_code':'AL'},
                    {'full_name':'Algeria','alpha2_code':'DZ'},
                    {'full_name':'American Samoa','alpha2_code':'AS'},
                    {'full_name':'Andorra','alpha2_code':'AD'},
                    {'full_name':'Angola','alpha2_code':'AO'},
                    {'full_name':'Anguilla','alpha2_code':'AI'},
                    {'full_name':'Antarctica','alpha2_code':'AQ'},
                    {'full_name':'Antigua and Barbuda','alpha2_code':'AG'},
                    {'full_name':'Argentina','alpha2_code':'AR'},
                    {'full_name':'Armenia','alpha2_code':'AM'},
                    {'full_name':'Aruba','alpha2_code':'AW'},
                    {'full_name':'Australia','alpha2_code':'AU'},
                    {'full_name':'Austria','alpha2_code':'AT'},
                    {'full_name':'Azerbaijan','alpha2_code':'AZ'},
                    {'full_name':'Bahamas','alpha2_code':'BS'},
                    {'full_name':'Bahrain','alpha2_code':'BH'},
                    {'full_name':'Bangladesh','alpha2_code':'BD'},
                    {'full_name':'Barbados','alpha2_code':'BB'},
                    {'full_name':'Belarus','alpha2_code':'BY'},
                    {'full_name':'Belgium','alpha2_code':'BE'},
                    {'full_name':'Belize','alpha2_code':'BZ'},
                    {'full_name':'Benin','alpha2_code':'BJ'},
                    {'full_name':'Bermuda','alpha2_code':'BM'},
                    {'full_name':'Bhutan','alpha2_code':'BT'},
                    {'full_name':'Bolivia, Plurinational State of','alpha2_code':'BO'},
                    {'full_name':'Bolivia','alpha2_code':'BO'},
                    {'full_name':'Bosnia and Herzegovina','alpha2_code':'BA'},
                    {'full_name':'Botswana','alpha2_code':'BW'},
                    {'full_name':'Bouvet Island','alpha2_code':'BV'},
                    {'full_name':'Brazil','alpha2_code':'BR'},
                    {'full_name':'British Indian Ocean Territory','alpha2_code':'IO'},
                    {'full_name':'Brunei Darussalam','alpha2_code':'BN'},
                    {'full_name':'Brunei','alpha2_code':'BN'},
                    {'full_name':'Bulgaria','alpha2_code':'BG'},
                    {'full_name':'Burkina Faso','alpha2_code':'BF'},
                    {'full_name':'Burundi','alpha2_code':'BI'},
                    {'full_name':'Cambodia','alpha2_code':'KH'},
                    {'full_name':'Cameroon','alpha2_code':'CM'},
                    {'full_name':'Canada','alpha2_code':'CA'},
                    {'full_name':'Cape Verde','alpha2_code':'CV'},
                    {'full_name':'Cayman Islands','alpha2_code':'KY'},
                    {'full_name':'Central African Republic','alpha2_code':'CF'},
                    {'full_name':'Chad','alpha2_code':'TD'},
                    {'full_name':'Chile','alpha2_code':'CL'},
                    {'full_name':'China','alpha2_code':'CN'},
                    {'full_name':'Christmas Island','alpha2_code':'CX'},
                    {'full_name':'Cocos (Keeling) Islands','alpha2_code':'CC'},
                    {'full_name':'Colombia','alpha2_code':'CO'},
                    {'full_name':'Comoros','alpha2_code':'KM'},
                    {'full_name':'Congo','alpha2_code':'CG'},
                    {'full_name':'Congo, the Democratic Republic of the','alpha2_code':'CD'},
                    {'full_name':'Cook Islands','alpha2_code':'CK'},
                    {'full_name':'Costa Rica','alpha2_code':'CR'},
                    {'full_name':'Côte d\'Ivoire','alpha2_code':'CI'},
                    {'full_name':'Ivory Coast','alpha2_code':'CI'},
                    {'full_name':'Croatia','alpha2_code':'HR'},
                    {'full_name':'Cuba','alpha2_code':'CU'},
                    {'full_name':'Cyprus','alpha2_code':'CY'},
                    {'full_name':'Czech Republic','alpha2_code':'CZ'},
                    {'full_name':'Denmark','alpha2_code':'DK'},
                    {'full_name':'Djibouti','alpha2_code':'DJ'},
                    {'full_name':'Dominica','alpha2_code':'DM'},
                    {'full_name':'Dominican Republic','alpha2_code':'DO'},
                    {'full_name':'Ecuador','alpha2_code':'EC'},
                    {'full_name':'Egypt','alpha2_code':'EG'},
                    {'full_name':'El Salvador','alpha2_code':'SV'},
                    {'full_name':'Equatorial Guinea','alpha2_code':'GQ'},
                    {'full_name':'Eritrea','alpha2_code':'ER'},
                    {'full_name':'Estonia','alpha2_code':'EE'},
                    {'full_name':'Ethiopia','alpha2_code':'ET'},
                    {'full_name':'Falkland Islands (Malvinas)','alpha2_code':'FK'},
                    {'full_name':'Faroe Islands','alpha2_code':'FO'},
                    {'full_name':'Fiji','alpha2_code':'FJ'},
                    {'full_name':'Finland','alpha2_code':'FI'},
                    {'full_name':'France','alpha2_code':'FR'},
                    {'full_name':'French Guiana','alpha2_code':'GF'},
                    {'full_name':'French Polynesia','alpha2_code':'PF'},
                    {'full_name':'French Southern Territories','alpha2_code':'TF'},
                    {'full_name':'Gabon','alpha2_code':'GA'},
                    {'full_name':'Gambia','alpha2_code':'GM'},
                    {'full_name':'Georgia','alpha2_code':'GE'},
                    {'full_name':'Germany','alpha2_code':'DE'},
                    {'full_name':'Ghana','alpha2_code':'GH'},
                    {'full_name':'Gibraltar','alpha2_code':'GI'},
                    {'full_name':'Greece','alpha2_code':'GR'},
                    {'full_name':'Greenland','alpha2_code':'GL'},
                    {'full_name':'Grenada','alpha2_code':'GD'},
                    {'full_name':'Guadeloupe','alpha2_code':'GP'},
                    {'full_name':'Guam','alpha2_code':'GU'},
                    {'full_name':'Guatemala','alpha2_code':'GT'},
                    {'full_name':'Guernsey','alpha2_code':'GG'},
                    {'full_name':'Guinea','alpha2_code':'GN'},
                    {'full_name':'Guinea-Bissau','alpha2_code':'GW'},
                    {'full_name':'Guyana','alpha2_code':'GY'},
                    {'full_name':'Haiti','alpha2_code':'HT'},
                    {'full_name':'Heard Island and McDonald Islands','alpha2_code':'HM'},
                    {'full_name':'Holy See (Vatican City State)','alpha2_code':'VA'},
                    {'full_name':'Honduras','alpha2_code':'HN'},
                    {'full_name':'Hong Kong','alpha2_code':'HK'},
                    {'full_name':'Hungary','alpha2_code':'HU'},
                    {'full_name':'Iceland','alpha2_code':'IS'},
                    {'full_name':'India','alpha2_code':'IN'},
                    {'full_name':'Indonesia','alpha2_code':'ID'},
                    {'full_name':'Iran, Islamic Republic of','alpha2_code':'IR'},
                    {'full_name':'Iraq','alpha2_code':'IQ'},
                    {'full_name':'Ireland','alpha2_code':'IE'},
                    {'full_name':'Isle of Man','alpha2_code':'IM'},
                    {'full_name':'Israel','alpha2_code':'IL'},
                    {'full_name':'Italy','alpha2_code':'IT'},
                    {'full_name':'Jamaica','alpha2_code':'JM'},
                    {'full_name':'Japan','alpha2_code':'JP'},
                    {'full_name':'Jersey','alpha2_code':'JE'},
                    {'full_name':'Jordan','alpha2_code':'JO'},
                    {'full_name':'Kazakhstan','alpha2_code':'KZ'},
                    {'full_name':'Kenya','alpha2_code':'KE'},
                    {'full_name':'Kiribati','alpha2_code':'KI'},
                    {'full_name':'Korea, Democratic People\'s Republic of','alpha2_code':'KP'},
                    {'full_name':'Korea, Republic of','alpha2_code':'KR'},
                    {'full_name':'South Korea','alpha2_code':'KR'},
                    {'full_name':'Kuwait','alpha2_code':'KW'},
                    {'full_name':'Kyrgyzstan','alpha2_code':'KG'},
                    {'full_name':'Lao People\'s Democratic Republic','alpha2_code':'LA'},
                    {'full_name':'Latvia','alpha2_code':'LV'},
                    {'full_name':'Lebanon','alpha2_code':'LB'},
                    {'full_name':'Lesotho','alpha2_code':'LS'},
                    {'full_name':'Liberia','alpha2_code':'LR'},
                    {'full_name':'Libyan Arab Jamahiriya','alpha2_code':'LY'},
                    {'full_name':'Libya','alpha2_code':'LY'},
                    {'full_name':'Liechtenstein','alpha2_code':'LI'},
                    {'full_name':'Lithuania','alpha2_code':'LT'},
                    {'full_name':'Luxembourg','alpha2_code':'LU'},
                    {'full_name':'Macao','alpha2_code':'MO'},
                    {'full_name':'Macedonia, the former Yugoslav Republic of','alpha2_code':'MK'},
                    {'full_name':'Madagascar','alpha2_code':'MG'},
                    {'full_name':'Malawi','alpha2_code':'MW'},
                    {'full_name':'Malaysia','alpha2_code':'MY'},
                    {'full_name':'Maldives','alpha2_code':'MV'},
                    {'full_name':'Mali','alpha2_code':'ML'},
                    {'full_name':'Malta','alpha2_code':'MT'},
                    {'full_name':'Marshall Islands','alpha2_code':'MH'},
                    {'full_name':'Martinique','alpha2_code':'MQ'},
                    {'full_name':'Mauritania','alpha2_code':'MR'},
                    {'full_name':'Mauritius','alpha2_code':'MU'},
                    {'full_name':'Mayotte','alpha2_code':'YT'},
                    {'full_name':'Mexico','alpha2_code':'MX'},
                    {'full_name':'Micronesia, Federated States of','alpha2_code':'FM'},
                    {'full_name':'Moldova, Republic of','alpha2_code':'MD'},
                    {'full_name':'Monaco','alpha2_code':'MC'},
                    {'full_name':'Mongolia','alpha2_code':'MN'},
                    {'full_name':'Montenegro','alpha2_code':'ME'},
                    {'full_name':'Montserrat','alpha2_code':'MS'},
                    {'full_name':'Morocco','alpha2_code':'MA'},
                    {'full_name':'Mozambique','alpha2_code':'MZ'},
                    {'full_name':'Myanmar','alpha2_code':'MM'},
                    {'full_name':'Burma','alpha2_code':'MM'},
                    {'full_name':'Namibia','alpha2_code':'NA'},
                    {'full_name':'Nauru','alpha2_code':'NR'},
                    {'full_name':'Nepal','alpha2_code':'NP'},
                    {'full_name':'Netherlands','alpha2_code':'NL'},
                    {'full_name':'Netherlands Antilles','alpha2_code':'AN'},
                    {'full_name':'New Caledonia','alpha2_code':'NC'},
                    {'full_name':'New Zealand','alpha2_code':'NZ'},
                    {'full_name':'Nicaragua','alpha2_code':'NI'},
                    {'full_name':'Niger','alpha2_code':'NE'},
                    {'full_name':'Nigeria','alpha2_code':'NG'},
                    {'full_name':'Niue','alpha2_code':'NU'},
                    {'full_name':'Norfolk Island','alpha2_code':'NF'},
                    {'full_name':'Northern Mariana Islands','alpha2_code':'MP'},
                    {'full_name':'Norway','alpha2_code':'NO'},
                    {'full_name':'Oman','alpha2_code':'OM'},
                    {'full_name':'Pakistan','alpha2_code':'PK'},
                    {'full_name':'Palau','alpha2_code':'PW'},
                    {'full_name':'Palestinian Territory, Occupied','alpha2_code':'PS'},
                    {'full_name':'Panama','alpha2_code':'PA'},
                    {'full_name':'Papua New Guinea','alpha2_code':'PG'},
                    {'full_name':'Paraguay','alpha2_code':'PY'},
                    {'full_name':'Peru','alpha2_code':'PE'},
                    {'full_name':'Philippines','alpha2_code':'PH'},
                    {'full_name':'Pitcairn','alpha2_code':'PN'},
                    {'full_name':'Poland','alpha2_code':'PL'},
                    {'full_name':'Portugal','alpha2_code':'PT'},
                    {'full_name':'Puerto Rico','alpha2_code':'PR'},
                    {'full_name':'Qatar','alpha2_code':'QA'},
                    {'full_name':'Réunion','alpha2_code':'RE'},
                    {'full_name':'Romania','alpha2_code':'RO'},
                    {'full_name':'Russian Federation','alpha2_code':'RU'},
                    {'full_name':'Russia','alpha2_code':'RU'},
                    {'full_name':'Rwanda','alpha2_code':'RW'},
                    {'full_name':'Saint Helena, Ascension and Tristan da Cunha','alpha2_code':'SH'},
                    {'full_name':'Saint Kitts and Nevis','alpha2_code':'KN'},
                    {'full_name':'Saint Lucia','alpha2_code':'LC'},
                    {'full_name':'Saint Pierre and Miquelon','alpha2_code':'PM'},
                    {'full_name':'Saint Vincent and the Grenadines','alpha2_code':'VC'},
                    {'full_name':'Saint Vincent & the Grenadines','alpha2_code':'VC'},
                    {'full_name':'St. Vincent and the Grenadines','alpha2_code':'VC'},
                    {'full_name':'Samoa','alpha2_code':'WS'},
                    {'full_name':'San Marino','alpha2_code':'SM'},
                    {'full_name':'Sao Tome and Principe','alpha2_code':'ST'},
                    {'full_name':'Saudi Arabia','alpha2_code':'SA'},
                    {'full_name':'Senegal','alpha2_code':'SN'},
                    {'full_name':'Serbia','alpha2_code':'RS'},
                    {'full_name':'Seychelles','alpha2_code':'SC'},
                    {'full_name':'Sierra Leone','alpha2_code':'SL'},
                    {'full_name':'Singapore','alpha2_code':'SG'},
                    {'full_name':'Slovakia','alpha2_code':'SK'},
                    {'full_name':'Slovenia','alpha2_code':'SI'},
                    {'full_name':'Solomon Islands','alpha2_code':'SB'},
                    {'full_name':'Somalia','alpha2_code':'SO'},
                    {'full_name':'South Africa','alpha2_code':'ZA'},
                    {'full_name':'South Georgia and the South Sandwich Islands','alpha2_code':'GS'},
                    {'full_name':'South Sudan','alpha2_code':'SS'},
                    {'full_name':'Spain','alpha2_code':'ES'},
                    {'full_name':'Sri Lanka','alpha2_code':'LK'},
                    {'full_name':'Sudan','alpha2_code':'SD'},
                    {'full_name':'Suriname','alpha2_code':'SR'},
                    {'full_name':'Svalbard and Jan Mayen','alpha2_code':'SJ'},
                    {'full_name':'Swaziland','alpha2_code':'SZ'},
                    {'full_name':'Sweden','alpha2_code':'SE'},
                    {'full_name':'Switzerland','alpha2_code':'CH'},
                    {'full_name':'Syrian Arab Republic','alpha2_code':'SY'},
                    {'full_name':'Taiwan, Province of China','alpha2_code':'TW'},
                    {'full_name':'Taiwan','alpha2_code':'TW'},
                    {'full_name':'Tajikistan','alpha2_code':'TJ'},
                    {'full_name':'Tanzania, United Republic of','alpha2_code':'TZ'},
                    {'full_name':'Thailand','alpha2_code':'TH'},
                    {'full_name':'Timor-Leste','alpha2_code':'TL'},
                    {'full_name':'Togo','alpha2_code':'TG'},
                    {'full_name':'Tokelau','alpha2_code':'TK'},
                    {'full_name':'Tonga','alpha2_code':'TO'},
                    {'full_name':'Trinidad and Tobago','alpha2_code':'TT'},
                    {'full_name':'Tunisia','alpha2_code':'TN'},
                    {'full_name':'Turkey','alpha2_code':'TR'},
                    {'full_name':'Turkmenistan','alpha2_code':'TM'},
                    {'full_name':'Turks and Caicos Islands','alpha2_code':'TC'},
                    {'full_name':'Tuvalu','alpha2_code':'TV'},
                    {'full_name':'Uganda','alpha2_code':'UG'},
                    {'full_name':'Ukraine','alpha2_code':'UA'},
                    {'full_name':'United Arab Emirates','alpha2_code':'AE'},
                    {'full_name':'United Kingdom','alpha2_code':'GB'},
                    {'full_name':'United States','alpha2_code':'US'},
                    {'full_name':'United States Minor Outlying Islands','alpha2_code':'UM'},
                    {'full_name':'Uruguay','alpha2_code':'UY'},
                    {'full_name':'Uzbekistan','alpha2_code':'UZ'},
                    {'full_name':'Vanuatu','alpha2_code':'VU'},
                    {'full_name':'Venezuela, Bolivarian Republic of','alpha2_code':'VE'},
                    {'full_name':'Venezuela','alpha2_code':'VE'},
                    {'full_name':'Viet Nam','alpha2_code':'VN'},
                    {'full_name':'Vietnam','alpha2_code':'VN'},
                    {'full_name':'Virgin Islands, British','alpha2_code':'VG'},
                    {'full_name':'Virgin Islands, U.S.','alpha2_code':'VI'},
                    {'full_name':'Wallis and Futuna','alpha2_code':'WF'},
                    {'full_name':'Western Sahara','alpha2_code':'EH'},
                    {'full_name':'Yemen','alpha2_code':'YE'},
                    {'full_name':'Zambia','alpha2_code':'ZM'},
                    {'full_name':'Zimbabwe','alpha2_code':'ZW'}
                ],
                cache_data_label: {
                    contact_type: 'Type',
                    email: 'Email',
                    mobile: 'Mobile',
                    phone1: 'Phone',
                    phone2: 'Alternate Phone',
                    tax_number: 'TFN (Tax File Number)',
                    address_id: 'Address',     // Ignored if contact_type = 'Joint Member'

                    // Fields below for contact_type = 'People'
                    first_name: 'First Name',
                    middle_name: 'Middle Name',
                    last_name: 'Last Name',
                    title: 'Title',
                    sex: 'Gender',
                    birthday: 'Date of Birth',
                    birth_place: 'Birth Place/City/Locality',
                    birth_state: 'Birth State',
                    birth_country: 'Birth Country',
                    director_id: 'Director ID',
                    // Fields below for contact_type = 'Company'/'Other Entity'. Nevertheless, 'Other Entity' is probably not applicable in our site
                    name:'Organization Name',
                    company_number:'A.C.N.',
                    business_number:'A.B.N.',
                    place_of_incorporation:'Register Place',
                    incorporation_date:'Register Date',
                    // Field type is only for 'Other Entity' and is assumed never going to be used in our site
                    // type:''
                    // Fields below for contact_typ = 'Joint Member'
                    representative_ids:'Represnetatives'
                },
                message_option: {
                    message: '',
                    message_type: ''
                },
            };
            let current_object = this;
            data_set.cache_data = current_object.reset_cache_data({init:true});
            Object.keys(current_object.option).forEach(function (option_key) {
                data_set[option_key] = current_object.option[option_key];
            });
            return data_set;
        },
        computed: {
            available_contact_types: function () {
                switch (this.contact_for) {
                    case 'officer':
                        return ['People'];
                        break;
                    case 'shareholder':
                        return ['People','Company','Joint Member'];
                        break;
                    case 'beneficial_owner':
                        return ['People','Company','Trust'];
                        break;
                    case 'joint_member':
                    case 'trustee':
                    case 'beneficiary':
                    case 'settlor':
                    case 'appointor':
                    case 'excluded_class':
                    case 'controller':
                    case 'unit_holder':
                        return ['People','Company'];
                        break;
                    case 'trust':
                        return ['Trust','Smsf','Partnership','Other Entity'];
                        break;
                    default:
                        return ['People','Company','Partnership','Smsf','Trust','Other Entity','Joint Member'];
                }
            }
        },
        methods: {
            contact_type_display_name: function(contact_type) {
                if (contact_type === 'People') {
                    return 'Individual';
                }
                return contact_type;
            },
            reset_cache_data: function(option) {
                if (typeof option === 'undefined') {
                    option = {};
                }

                let current_object = this;

                let cache_data = {
                    contact_type: 'People',     // 'People'/'Company'/Other Entity’/’Joint Member’
                    email: '',
                    mobile: '',
                    phone1: '',
                    phone2: '',
                    tax_number: '',
                    address_id: '',     // Ignored if contact_type = 'Joint Member'

                    // Fields below for contact_type = 'People'
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    title: '',
                    sex: '',
                    birthday: '',
                    birth_place: '',
                    birth_state: '',
                    birth_country: 'AU',
                    director_id: '',
                    // Fields below for contact_type = 'Company'/'Other Entity'. Nevertheless, 'Other Entity' is probably not applicable in our site
                    name:'',
                    company_number:'',
                    business_number:'',
                    place_of_incorporation:'',
                    incorporation_date:'',
                    // 'Joint Member'
                    representative_ids:[]
                };
                if (!option.init) {
                    current_object.cache_data = Object.assign(current_object.cache_data,cache_data);
                    cache_data = current_object.cache_data;
                }

                current_object.current_contact = {};
                if (current_object.current_contact_id && current_object.option) {
                    if (current_object.option.item_map.contacts[current_object.current_contact_id]) {
                        cache_data = Object.assign(cache_data, current_object.item_map.contacts[current_object.current_contact_id]);
                        current_object.current_contact = current_object.item_map.contacts[current_object.current_contact_id];
                    }
                }

                if (cache_data.contact_type == 'Other Entity') {
                    if (cache_data.type) {
                        cache_data.contact_type = cache_data.type;
                    } else {
                        cache_data.contact_type = 'Other';
                    }
                }


                return cache_data;

            },
            update_representative: function(contact_id) {
                let current_object = this;

                if (contact_id) {
                    if (current_object.cache_data.representative_ids.indexOf(contact_id) == -1) {
                        current_object.cache_data.representative_ids.push(contact_id);
                    }
                } else {
                    if (current_object.cache_data.representative_ids.indexOf(contact_id) != -1) {
                        current_object.cache_data.representative_ids.splice(current_object.cache_data.representative_ids.indexOf(contact_id),1);
                    }
                }
                current_object.current_representative_id = '';

                // if (!contact_id) {
                //     this.cache_data.contact_id = '';
                // } else {
                //     this.cache_data.contact_id = contact_id;
                // }
                // this.current_contact_id = '';
            },
            save: function () {
                let current_object = this;
                let warning_message = [];
                let mandatory_fields = [];
                let formatted_name = '';
                let post_data = Object.assign({},current_object.cache_data);

                current_object.message_option.message = '';

                switch (post_data.contact_type) {
                    case 'People':
                        formatted_name = post_data.last_name;
                        if (post_data.middle_name) {
                            formatted_name = post_data.middle_name + ' ' + formatted_name;
                        }
                        if (post_data.first_name) {
                            formatted_name = post_data.first_name + ' ' + formatted_name;
                        }
                        if (post_data.title) {
                            formatted_name = post_data.title + ' ' + formatted_name;
                        }

                        post_data.formatted_name = formatted_name;

                        if (post_data.birth_country !== 'AU') {
                            post_data.birth_state = 'Foreign';
                        }
                        mandatory_fields.splice(0,0,'address_id','first_name','last_name');
                        if (current_object.contact_for === 'officer') {
                            // For officers, contact person's birthday and birth country are mandatory
                            mandatory_fields.push('birthday');
                            mandatory_fields.push('birth_country');
                            mandatory_fields.push('birth_state');
                            mandatory_fields.push('birth_place');
                        }
                        if (post_data.director_id) {
                            // Director ID validation, 15 digits start with 036 as Australian country code, last digit for check (not sure about the algorithm yet)
                            let stripped_director_id = post_data.director_id.replace(/[^0-9]+/g, '');
                            if (!stripped_director_id.match(/^036(\d){12}/)) {
                                warning_message.push('Invalid Director ID.');
                            }
                        }
                        break;
                    case 'Joint Member':
                        let i = 0;
                        let name_stack = [];
                        while (post_data.representative_ids[i]) {
                            name_stack.push(current_object.item_map.contacts[post_data.representative_ids[i]].formatted_name);
                            i++;
                        }
                        post_data.formatted_name = 'Joint Member: '+name_stack.join(', ')+'';
                        if (i < 2) {
                            warning_message.push('Field "'+current_object.cache_data_label['representative_ids']+'" is required, Please select at least two representatives.');
                        }
                        // mandatory_fields.splice(0,0,'representative_ids');
                        break;
                    case 'Trust':
                        post_data.formatted_name = post_data.name;
                        break;
                    case 'Company':
                    default:
                        post_data.formatted_name = post_data.name;
                        if (post_data.business_number) {
                            post_data.formatted_name += ' (A.B.N. '+post_data.business_number + ')';
                        } else {
                            if (post_data.company_number) {
                                post_data.formatted_name += ' (A.C.N. '+post_data.company_number + ')';
                            } else {
                                if (post_data.contact_type === 'Company') {
                                    warning_message.push('Company must provide A.B.N. and/or A.C.N. for identification.');
                                }
                            }
                        }
                        mandatory_fields.splice(0,0,'address_id','name');
                        if (post_data.contact_type !== 'Company') {
                            post_data.type = post_data.contact_type.toUpperCase();
                            post_data.contact_type = 'Other Entity';
                        }
                        break;
                }
                if (post_data.email) {
                    if (!post_data.email.toLowerCase()
                        .match(
                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        )) {
                        warning_message.push('Invalid Email Address.');
                    }
                }
                if (post_data.tax_number) {
                    let stripped_tax_number = post_data.tax_number.replace(/[^0-9]+/g, '');
                    if (stripped_tax_number.length != 9 ) {
                        warning_message.push('Invalid Tax File Number.');
                    } else {
                        let digits = stripped_tax_number.split('');
                        let sum = (digits[0]*1)
                            + (digits[1]*4)
                            + (digits[2]*3)
                            + (digits[3]*7)
                            + (digits[4]*5)
                            + (digits[5]*8)
                            + (digits[6]*6)
                            + (digits[7]*9)
                            + (digits[8]*10);

                        if (sum % 11 != 0) {
                            warning_message.push('Invalid Tax File Number.');
                        }
                    }
                }
                // General Validation, e.g. mandatory field empty, number format wrong...
                mandatory_fields.forEach(function (field_name) {
                    if (!post_data[field_name]) {
                        warning_message.push('Field "'+current_object.cache_data_label[field_name]+'" is required.');
                    }
                });

                if (warning_message.length > 0) {
                    current_object.message_option.message_type = 'error';
                    current_object.message_option.message = warning_message;
                    return false;
                } else {
                    current_object.message_option.message_type = 'success';
                    current_object.message_option.message = '';
                }

                if (!current_object.current_contact.id) {
                    current_object.current_contact = Object.assign(current_object.current_contact,post_data);
                    let index_counter = 1;
                    while (current_object.item_map.contacts['new_'+index_counter]) {
                        index_counter++;
                    }
                    current_object.current_contact.id = 'new_'+index_counter;

                    current_object.item_map.contacts[current_object.current_contact.id] = current_object.current_contact;
                    current_object.item_list.contacts.push(current_object.current_contact);
                } else {
                    current_object.current_contact = Object.assign(current_object.current_contact,post_data);
                }

console.log('allen debug update contact submit',current_object.current_contact.id,current_object.contact_for,current_object.item_map,current_object.item_list,$(current_object.$el));
                // this.$emit('update:new_contact',this.cache_data.id);

                $('html, body').stop().animate({
                    scrollTop:$(current_object.$el).offset().top - 200
                }, 550, 'swing', function () {
                    // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                    // (calculated top position number is correct, it is kind of browser render problem)
                    // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                    // scrollTop:$(current_object.$el).offset().top - 200;
                });
                this.$emit('submit',current_object.current_contact.id,current_object.contact_for);
            },
            cancel: function () {
                let current_object = this;

                // Erase error message if applicable
                current_object.message_option.message_type = '';
                current_object.message_option.message = '';

console.log('allen debug update contact cancel',current_object.current_contact.id,current_object.contact_for,current_object.item_map,current_object.item_list);
                // this.$emit('update:new_contact','');
                $('html, body').stop().animate({
                    scrollTop:$(current_object.$el).offset().top - 200
                }, 550, 'swing', function () {
                    // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                    // (calculated top position number is correct, it is kind of browser render problem)
                    // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                    // scrollTop:$(current_object.$el).offset().top - 200;
                });
                this.$emit('submit',this.current_contact.id?this.current_contact.id:'',this.contact_for);
            }
        },
        watch: {
            current_contact_id: function () {
                let current_object = this;

                current_object.reset_cache_data();
                current_object.message_option.message = '';
                current_object.message_option.message_type = '';
            }
        }
    }
</script>